import {
  Box,
  Button,
  Divider,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
  Zoom,
} from '@mui/material';
import Underline from '@tiptap/extension-underline';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../../redux/usersRedux';
import { loadReportPZ04ByIdRequest } from '../../../redux/reportsPZ04Redux';
import {
  createMicro5Request,
  updateMicro5Request,
} from '../../../redux/microbiologyRedux';

const Micro_5 = ({ props }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => getUser(state));
  const { t } = useTranslation();
  const [summaryDetails, setSummaryDetails] = useState(
    props.micro_5_summary ? props.micro_5_summary.summaryDetails : '',
  );
  const [reloadReport, setReloadReport] = useState(0);

  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        bulletList: { keepMarks: true, keepAttributes: false },
        orderedList: { keepMarks: true, keepAttributes: false },
      }),
      Underline,
    ],
    content: summaryDetails,
    onUpdate: ({ editor }) => {
      const html = editor.getHTML(); // Pobiera HTML z edytora
      setSummaryDetails(html); // Ustawia stan z HTML
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const summaryDetailsData = {
      reportPZ04Id: props.id,
      userId: user.users.id,
      summaryDetails,
    };
    if (!props.micro_5_summary) {
      const res = await dispatch(createMicro5Request(summaryDetailsData));
      if (res.status === 201) {
        setReloadReport(reloadReport + 1);
        console.log('Micro 5 summary created successfully', res);
      } else {
        console.log('Error creating Micro 5 summary', res);
      }
    } else {
      const res = await dispatch(
        updateMicro5Request({
          id: props.micro_5_summary.id,
          ...summaryDetailsData,
        }),
      );
      if (res.status === 200) {
        setReloadReport(reloadReport + 1);
        console.log('Micro 5 summary updated successfully', res);
      } else {
        console.log('Error updating Micro 5 summary', res);
      }
    }
  };
  useEffect(() => {
    const start = async () => {
      const res = await dispatch(loadReportPZ04ByIdRequest(props.id));
      if (res) {
        setSummaryDetails(
          res.data.micro_5_summary
            ? res.data.micro_5_summary.summaryDetails
            : '',
        );
      }
    };
    start();
  }, [dispatch, props.id, reloadReport]);

  return (
    <Box
      sx={{ overflow: 'auto', maxHeight: 'calc(100vh - 200px)' }}
      component={'form'}
      onSubmit={handleSubmit}
    >
      <Typography
        variant="h6"
        component="h2"
        width="300px"
        gutterBottom
        fontWeight="bold"
        fontStyle="italic"
      >
        {t('rnModule.stage_5.additionalDescription')}
      </Typography>
      <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
      {editor && (
        <Stack direction="row" spacing={1} mb={1}>
          <IconButton
            onClick={() => editor.chain().focus().toggleBold().run()}
            sx={{
              color: editor.isActive('bold') ? 'primary.main' : 'inherit',
              bgcolor: editor.isActive('bold')
                ? 'action.selected'
                : 'transparent',
            }}
          >
            <FormatBoldIcon />
          </IconButton>
          <IconButton
            onClick={() => editor.chain().focus().toggleItalic().run()}
            sx={{
              color: editor.isActive('italic') ? 'primary.main' : 'inherit',
              bgcolor: editor.isActive('italic')
                ? 'action.selected'
                : 'transparent',
            }}
          >
            <FormatItalicIcon />
          </IconButton>
          <IconButton
            onClick={() => editor.chain().focus().toggleUnderline().run()}
            sx={{
              color: editor.isActive('underline') ? 'primary.main' : 'inherit',
              bgcolor: editor.isActive('underline')
                ? 'action.selected'
                : 'transparent',
            }}
          >
            <FormatUnderlinedIcon />
          </IconButton>
          <IconButton
            onClick={() => editor.chain().focus().toggleOrderedList().run()}
            sx={{
              color: editor.isActive('orderedList')
                ? 'primary.main'
                : 'inherit',
              bgcolor: editor.isActive('orderedList')
                ? 'action.selected'
                : 'transparent',
            }}
          >
            <FormatListNumberedIcon />
          </IconButton>
          <IconButton
            onClick={() => editor.chain().focus().toggleBulletList().run()}
            sx={{
              color: editor.isActive('bulletList') ? 'primary.main' : 'inherit',
              bgcolor: editor.isActive('bulletList')
                ? 'action.selected'
                : 'transparent',
            }}
          >
            <FormatListBulletedIcon />
          </IconButton>
        </Stack>
      )}
      <Paper
        variant="outlined"
        sx={{
          borderRadius: 2,
          minHeight: 450,
          cursor: 'text', // Dodaj kursor
          '& .ProseMirror': {
            // Stylujemy wewnętrzny element edytora
            minHeight: '400px', // Dzięki temu będzie miejsce do klikania
          },
        }}
      >
        <EditorContent editor={editor} />
      </Paper>

      <Button
        type="submit"
        sx={{
          color: 'white',
          bgcolor: '#C09A53',
          ':hover': { bgcolor: '#9c7c43' },
          height: '40px',
          width: '150px',
          mt: 2,
          mb: 50,
        }}
      >
        {t('rnModule.stage_1.confirmationFirstStep')}
      </Button>
    </Box>
  );
};

export default Micro_5;
